import type { AI_OPS } from './chat-message';

// types of editor suggestion
export interface EditorSuggestion {
  id: string;
  op: AI_OPS;
  timestamp: number;
  selection_str?: string;
  new_str?: string;
}

export type LLMBaseDataSnapshot = {
  snapshot: DocSnapshot | null;
  markdown: string;
  blockLineMapping: BlockMarkdownMap[];
  docId: string;
};


export type SuggestionType = 'replace' | 'delete' | 'insert';

// export type SuggestionStatus = 'pending' | 'applied' | 'rejected';

export interface Suggestion {
  id: string;
  batch_id: string;
  type: SuggestionType;
  targetBlockIds: string[];
  newBlockIds?: string[];
  newBlocksData?: BlockModel[];
  status: SuggestionStatus;
  createdAt: number;
  chatCommand: InsertOps | DeleteOps | ReplaceOps;
}

export enum SuggestionBatchStatus {
  Delete = 'delete',
  Initial = 'initial',
  Pending = 'pending',
  Accepted = 'accepted',
  Rejected = 'rejected',
}

export interface SuggestionBatch {
  id: string;
  status: SuggestionBatchStatus;
  createdAt: number;
  suggestions: Suggestion[];
}

export enum SuggestionStatus {
  Initial = 'initial',
  Pending = 'pending',
  Accepted = 'accepted',
  Rejected = 'rejected',
  Conflict = 'conflict',
  Deleted = 'deleted',
}
